import React, {forwardRef} from 'react';
import { Carousel } from 'react-bootstrap';

import '../assets/css/CollectionMainInfoPageVer.css'

import TFAILogoMain from '../assets/images/TFAI-logo-main.svg'
import CollectionMaininfoPageCell from "./CollectionMaininfoPageCell";
import { AND, OR, NOT } from '../config';

const ComponentToPrint = forwardRef(({dataDisplay,searchWord,type,dataInfo,urlType}, ref) => {

    const getTime = () => {
        let d = new Date()
        return d.toLocaleString()
    }

    const wordArray = searchWord.split(new RegExp(`(${AND}|${OR}|${NOT})`, 'i'))
    let skipNext = false
    const searchArray = wordArray.filter((element) => {
        if (element === '' || element === AND || element === OR || skipNext) {
          skipNext = false;
          return false;
        } else if (element === NOT) {
          skipNext = true;
          return false;
        }
        return true;
    });

    // 判斷關鍵字是否需要添加 highlight 樣式
    const renderWithHighlight = (text) => {
        if (searchArray.length > 0 && text !== null) {
            const sortedArray = searchArray.sort((a, b) => b.length - a.length);
            const regex = new RegExp(sortedArray.join('|'), 'gi');
            // Matches array needed to maintain the correct letter casing
            const matches = [...text.matchAll(regex)];
            return text.split(regex).map((part, index) => (
              `${part}${index<matches.length ? `<div key={index} style="background-color: rgb(255, 255, 94); color: black; display: math;">${matches[index]}</div>` : ''}`
            )).join('');
        }
        return text   
    }

    const filmJSONlist = (colName, list) =>{
        if(colName==="演員表"){                                         
            return list.map((item, index) => (
                <div key={index+1} dangerouslySetInnerHTML={{ __html: renderWithHighlight((Object.keys(item)[0]===""?"":Object.keys(item)[0]+" ： ") + Object.values(item)[0]) }}/>
            ))
        }else if(colName==="職員表"){
            return list.map((item, index) => (
                <div key={index+1} dangerouslySetInnerHTML={{ __html: renderWithHighlight(Object.keys(item)[0]+" : "+Object.values(item)[0]) }}/>
            ))
        }
        return null
    }

    const createMedia = () => {
        switch(urlType){
            case 1:                
                return (
                    <div>
                    {dataInfo && dataInfo.圖檔URL ?             
                        <div><img alt="rfurl" src={dataInfo.圖檔URL} style={{width:'100%',objectFit:'cover'}}></img></div>                
                    : null}
                    </div>
                ) 
            case 2:
                return (
                    <Carousel>
                    {dataInfo && dataInfo.圖檔URL ?    
                        getCarousel(dataInfo.圖檔URL)             
                        : null
                    }
                    </Carousel>
                )
            case 3:
                return (
                    <div>
                    {dataInfo && dataInfo.原始藏品編號 ?                        
                        <div>
                            <div>
                                <iframe title="dfsrc" style={{width:'100%',height:'300px'}}
                                    src={'https://vcenter.iis.sinica.edu.tw/videojs/watch_frame_for_digitalarchives.php?id='+dataInfo.原始藏品編號+'&fn='+dataInfo.原始藏品編號} allowFullScreen>
                                </iframe>
                            </div>
                            <div>{"#影片撥放需等候5~10秒載入，請耐心等候"}</div>
                        </div>
                        : null
                    }
                    </div>
                )
            default :
                return null
        }
    }
    const getCarousel = (url) => {
        let arrayUrl = url.split('|')
        return (  
            arrayUrl.map(url=>{
                return(                     
                    <Carousel.Item>
                        <img alt="itemimg" src={url} style={{width:'100%',objectFit:'cover'}}></img>
                    </Carousel.Item>
                )
            })           
        )
    }

    return (
        <div className="CollectionMainInfoMainBodyPrintPage" ref={ref}>
            <div>
                <div style={{display:'flex'}}>
                    <div style={{position:'relative',width:'220px'}}>
                        <div style={{position:'absolute',bottom:'0px',fontSize:'12px'}}>
                            {"國家電影及視聽文化中心 藏品檢索系統"}
                        </div>
                    </div>
                    <div>
                        <img alt="logo" src={TFAILogoMain}/>
                    </div>
                </div>
            </div>
            <div style={{display:'flex'}}>
                <div style={{width:'98%', margin:'1vw 1vw 0 1vw', fontSize:'20px'}}>
                    <div className="CollectionMainTitle" style={{borderBottom:'1px solid gray'}}>
                        <div className="CollectionMainInfoRow">
                            <div className="MovieTitle" style={{fontSize:'20px'}}>                                        
                                {dataDisplay && <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(dataDisplay.title) }} />}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="CollectionMainInfoTableBody">                 
                <div className='CollectionMainInfoTableColumnPrint'>
                    {dataDisplay && dataDisplay.blocks.map((item, index) => (
                        <div key={index} className="CollectionMainInfoMajorArea">
                            {item.alias==="" ? "" : 
                                <div className="CollectionMainInfoAreaPageVer">
                                    <div className="MovieRowTitle" >{item.alias}</div>
                                </div>}
                            {item.data.map((obj, i)=>(
                                <div key={i} className="CollectionMainInfoAreaPageVer">
                                    <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                                        <div className="CollectionMainInfoRowTitlePageVer" style={{fontSize:'12px'}}>{Object.keys(obj)[0]}</div>
                                        <div className="CollectionMainInfoRowContentPageVer" style={{fontSize:'12px'}}>  
                                            <CollectionMaininfoPageCell>
                                            {type==="film" && (Object.keys(obj)[0]==="職員表" || Object.keys(obj)[0]==="演員表") ? (
                                                filmJSONlist(Object.keys(obj)[0], Object.values(obj)[0]) 
                                            ) : (                             
                                                <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(Object.values(obj)[0]) }} />
                                            )}
                                            </CollectionMaininfoPageCell>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ))}             
                    {createMedia()}
                    <div className="CollectionMainInfoAreaPageVer">
                        <div className="MovieRowTitle" style={{fontSize:'14px'}}>{"管理權"}</div>
                    </div>
                    <div className="CollectionMainInfoAreaPageVer">
                        <div className="CollectionMainInfoRowTitlePageVer" style={{width:'100%',fontSize:'12px'}}>{"國家電影及視聽文化中心"}</div>
                    </div>
                </div>
            </div>
            <div style={{float:'right',paddingBottom:'50px'}} >
                <div>
                    <div style={{display:'flex',fontSize:'12px'}}>
                        <div>列印時間 ：</div>
                        <div>{getTime()}</div>
                    </div>
                </div>                
            </div>
        </div>
    )
})
export default ComponentToPrint;